/** Tab Sharing Method */
export const ECC_SHARE_METHOD = 'ecc';
export const FIELD_SHARE_METHOD = 'field';

export type TabSharingMethod =
  | typeof ECC_SHARE_METHOD
  | typeof FIELD_SHARE_METHOD;

/** Field Sharing */
export const FIELD_DIRECT_RECIPIENTS_SHARE = 'direct-recipients';
export const FIELD_SHARE_LINK_SHARE = 'share-link';
export const FIELD_IAR_SHARE = 'iar-share';

export type FieldSharingMethod =
  | typeof FIELD_DIRECT_RECIPIENTS_SHARE
  | typeof FIELD_SHARE_LINK_SHARE
  | typeof FIELD_IAR_SHARE;

/**
 * Share methods that produce a shareable link (and skip the direct-recipients
 * flow). Grouped here so call sites stay in sync instead of repeating the pair.
 */
export const LINK_BASED_SHARE_METHODS: FieldSharingMethod[] = [
  FIELD_SHARE_LINK_SHARE,
  FIELD_IAR_SHARE,
];

export const isLinkBasedShare = (method: FieldSharingMethod): boolean =>
  LINK_BASED_SHARE_METHODS.includes(method);
